export const EMPTY_DRAFT_FIELD = '<p><br></p>';
//# sourceMappingURL=constants.js.map